import { useCallback, useState } from "react";

const useSnackbarState = () => {
  const [errorSnackbar, setErrorSnackbar] = useState({
    open: false,
    message: "",
  });
  const [successSnackbar, setSuccessSnackbar] = useState({
    open: false,
    message: "",
  });

  const showError = useCallback((message) => {
    setErrorSnackbar({ open: true, message });
  }, []);

  const showSuccess = useCallback((message) => {
    setSuccessSnackbar({ open: true, message });
  }, []);

  const closeError = useCallback(() => {
    setErrorSnackbar({ open: false, message: "" });
  }, []);

  const closeSuccess = useCallback(() => {
    setSuccessSnackbar({ open: false, message: "" });
  }, []);

  return {
    errorSnackbar,
    successSnackbar,
    showError,
    showSuccess,
    closeError,
    closeSuccess,
  };
};

export default useSnackbarState;
